import { call, put, select } from 'redux-saga/effects'
import zohoValidationMock from '@/containers/SubscriptionFormPageNew/mocks/zohoValidation.json'
import { addClientError, removeClientError, updateClientData } from '../../SubscriptionForm/SubscriptionFormSlice'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectExtraRoutesAuthData } from '../../../Login/AuthSelectors'
import { selectPersonalClientSubscriptionData } from '../../SubscriptionForm/SubscriptionFormSelectors'
import * as Sentry from '@sentry/react'

export const zohoModuleActions = {
  ZOHO_MODULE_VERIFY_ID_V2: 'ZOHO_MODULE_VERIFY_ID_V2',
  ZOHO_MODULE_UNLOCK_MCP_CLIENT_V2: 'ZOHO_MODULE_UNLOCK_MCP_CLIENT_V2',
}

export function* verifyZohoId({ zohoId }) {
  if (import.meta.env.DEV && zohoValidationMock[zohoId]) {
    yield put(
      updateClientData({
        data: { ...zohoValidationMock[zohoId] },
        name: 'config',
      }),
    )
    return
  }

  if (!zohoId) {
    return
  }

  const { verifyZohoIdUrl } = yield select(selectExtraRoutesAuthData)
  const endpoint = `${verifyZohoIdUrl}?value=${encodeURIComponent(zohoId)}`

  try {
    const { isMcp, isMcpLocked } = yield call(callApi, {
      endpoint,
      showErrorSnackbar: false,
      method: 'GET',
    })

    yield put(
      updateClientData({
        data: {
          isValidZohoId: true,
          isMcpClient: isMcp ?? false,
          isMcpLocked: isMcpLocked ?? false,
        },
        name: 'config',
      }),
    )
    yield put(removeClientError('zoho_id'))
  } catch (error) {
    yield put(addClientError({ key: 'zoho_id', message: error }))
    yield put(
      updateClientData({
        data: {
          isValidZohoId: false,
          isMcpClient: false,
          isMcpLocked: false,
        },
        name: 'config',
      }),
    )
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('verifyZohoIdError'), { extra: { error } })
    }
  }
}

export function* unlockMcpClient({ genericErrorMsg }) {
  yield put(
    updateClientData({
      data: { mcpUnlockError: null },
      name: 'config',
    }),
  )
  const { zohoId } = yield select(selectPersonalClientSubscriptionData)
  const { unlockMcpZohoUrl } = yield select(selectExtraRoutesAuthData)
  const endpoint = unlockMcpZohoUrl?.replace('*', zohoId)

  try {
    yield call(callApi, {
      endpoint,
      showErrorSnackbar: false,
      method: 'PUT',
    })
    yield put(updateClientData({ data: { isMcpLocked: false }, name: 'config' }))
  } catch (error) {
    yield put(
      updateClientData({
        data: { mcpUnlockError: error.toString() ?? genericErrorMsg },
        name: 'config',
      }),
    )
    if (import.meta.env.PROD) {
      Sentry.captureException(new Error('unlockMcpClientError'), { extra: { error } })
    }
  }
}
